import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import Bewerber from './pages/Bewerber';
import Unternehmen from './pages/Unternehmen';
import Jobbereiche from './pages/Jobbereiche';
import UeberUns from './pages/UeberUns';
import Kontakt from './pages/Kontakt';
import Legal from './pages/Legal';

// ScrollToTop Component
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen bg-white">
        <Navbar />
        <main className="flex-grow pt-20">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/bewerber" element={<Bewerber />} />
            <Route path="/unternehmen" element={<Unternehmen />} />
            <Route path="/jobbereiche" element={<Jobbereiche />} />
            <Route path="/ueber-uns" element={<UeberUns />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/impressum" element={<Legal title="Impressum" />} />
            <Route path="/datenschutz" element={<Legal title="Datenschutz" />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;